import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export function MaskedLines({ lines, className = "", lineClassName = "", delay = 0.15 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => {
        const text = typeof line === "string" ? line : line.text;
        const extra = typeof line === "string" ? "" : line.className || "";
        return (
          <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
            <motion.span
              className={`block ${lineClassName} ${extra}`}
              initial={{ y: "115%" }}
              animate={{ y: 0 }}
              transition={{ duration: 1, delay: delay + i * 0.15, ease: EASE }}
            >
              {text}
            </motion.span>
          </span>
        );
      })}
    </span>
  );
}

export function FadeUp({ children, delay = 0, className = "", y = 36, once = true }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once, margin: "-80px" }}
      transition={{ duration: 0.9, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function SectionTag({ children }) {
  return (
    <span className="inline-flex items-center gap-2 px-3 py-1 rounded-full text-xs font-mono uppercase tracking-[0.2em] bg-blue-50/70 text-blue-600 border border-blue-200/50">
      <span className="w-1.5 h-1.5 rotate-45 bg-blue-600" />
      {children}
    </span>
  );
}
